import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const SearchInput = styled.span<React.CSSProperties>`
  border: none;
  color: ${Colors['light']};
  background: none;
  display: -webkit-box;
  font-size: ${24 * Screen.widthRatio}px;
  font-family: ${Fonts['bold']};
  height: ${62 * Screen.widthRatio}px;
  margin-left: ${16 * Screen.widthRatio}px;
  margin-top: ${-4 * Screen.widthRatio}px;
  overflow: hidden;
  position: relative;
  text-overflow: ellipsis;
  width: ${722 * Screen.widthRatio}px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export default SearchInput;
